import { Controller } from "@hotwired/stimulus"

/**
 * CloudWatch Logs Controller
 * 
 * Manages CloudWatch log display and filtering functionality.
 * Provides filtering capabilities for log entries, particularly error filtering.
 * 
 * Features:
 * - Filters log rows to show only error entries
 * - Manages visibility of log table rows
 * - Provides console logging for debugging
 * 
 * Usage: Add data-controller="cloudwatch-logs" to CloudWatch log table containers
 */
export default class extends Controller {
  static targets = ["logRow"]
  
  connect() {}

  filterErrors() {
    const rows = this.element.querySelectorAll('tbody tr')
    rows.forEach(row => {
      const messageCell = row.querySelector('td:last-child')
      if (messageCell) {
        const message = messageCell.textContent
        if (message.includes('ERROR')) {
          row.style.display = 'table-row'
        } else {
          row.style.display = 'none'
        }
      }
    })
  }
} 